import { __assign } from "tslib";
import { safeParseDate } from '../utilities/DateUtilities';
import { processUserRelationship } from '../utilities/processUserRelationship';
export function parseDeltaSyncResponse(items) {
    if (!items) {
        throw new Error('Invalid delta sync response data');
    }
    /* eslint-disable @typescript-eslint/naming-convention */
    return items.map(function (file) {
        var userRelationship = file.user_relationship;
        var activities = file.activities
            ? file.activities.map(function (rawActivity) {
                var activity;
                try {
                    activity = JSON.parse(rawActivity.a);
                }
                catch (_a) {
                    console.log("Error parsing activity: ".concat(rawActivity.a));
                }
                return __assign(__assign({}, rawActivity), { t: safeParseDate(rawActivity.t), da: __assign(__assign({}, rawActivity.da), { t: safeParseDate(rawActivity.da.t) }), a: activity });
            })
            : [];
        var activityBadge = file.activity_badge
            ? __assign(__assign({}, file.activity_badge), { timestamp: safeParseDate(file.activity_badge.timestamp) }) : undefined;
        var creationInfo = file.creation_info
            ? __assign(__assign({}, file.creation_info), { timestamp: safeParseDate(file.creation_info.timestamp) }) : undefined;
        var modificationInfo = file.modification_info
            ? __assign(__assign({}, file.modification_info), { timestamp: safeParseDate(file.modification_info.timestamp) }) : undefined;
        return __assign(__assign({}, file), { last_recommended_modified_datetime: file.last_recommended_modified_datetime, last_store_modified_datetime: file.last_store_modified_datetime, user_relationship: processUserRelationship(userRelationship), activities: activities, activity_badge: activityBadge, created_datetime: safeParseDate(file.created_datetime), creation_info: creationInfo, modification_info: modificationInfo });
    });
    /* eslint-enable @typescript-eslint/naming-convention */
}
//# sourceMappingURL=parseDeltaSyncResponse.js.map